export default __webpack_public_path__ + "static/media/stock2.ee976fce.png";